var _rect, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 203,
    height: 203,
    fill: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "p",
    width: 7,
    height: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 14,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 21,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 28,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 35,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 42,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 49,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 56,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 63,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 70,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 77,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 84,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 91,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 98,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 105,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 112,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 119,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 63
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 126,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 133,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 140,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 147,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 154,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 133
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 161,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 168,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 70
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 77
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 105
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 175,
    y: 182
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 21
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 28
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 35
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 49
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 56
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 84
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 91
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 98
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 112
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 119
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 140
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 147
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 154
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 161
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 168
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 175
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    x: 182,
    y: 182
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadQrCode);
export default __webpack_public_path__ + "static/media/download-qr-code.dd7a47fdc0869f863de60bc6f508802e.svg";
export { ForwardRef as ReactComponent };